import { Theme, createStyles } from '@material-ui/core';

const awaitingRequestStyle = (theme: Theme) =>
    createStyles({
        arrowIcon: {
          margin: '0 5px',
        },
        coursePlanInfoBox: {
            backgroundColor: 'rgba(250, 74, 74, 0.1)',
            padding: '18px 18px 20px',
            '& .listingRow': {
                display: 'flex',
                marginBottom: '24px',
                '& .buttonText::after': {
                  display: 'none',
                }
            },
            '& .listing': {
                display: 'flex',
                alignSelf: 'center',
                padding: 0,
                margin: 0,
                listStyle: 'none',
                '& li': {
                    padding: '0 16px',
                    fontSize: '20px',
                    fontWeight: 400,
                    color: '#333333',
                    position: 'relative',
                    lineHeight: '135%',
                    "@media (max-width: 1365px)": {
                      fontSize: '17px',
                    },
                    '&::after': {
                        content: "''",
                        position: 'absolute',
                        right: 0,
                        width: '1px',
                        height: '28px',
                        backgroundColor: 'rgba(153, 153, 153, 0.4)',
                    },
                    "&:first-child": {
                        paddingLeft: 0,
                    },
                    "&:last-child::after": {
                        display: 'none',
                    },
                },
            },
            '& .buttonText': {
                fontSize: '16px',
                fontWeight: 600,
                color: '#1D7DEA',
                textDecoration: 'none',
                lineHeight: '22px',
                alignSelf: 'center',
                position: 'relative',
                cursor:'pointer',
                border:'none',
                outline:'none',
                background:'transparent',
                fontFamily: 'nunito',
                "@media (max-width: 1365px)": {
                  fontSize: '13px',
                },
                '&::after': {
                    content: "''",
                    right: 0,
                    top: 0,
                    width: '1px',
                    height: '28px',
                    backgroundColor: 'rgba(153, 153, 153, 0.4)',
                    margin: '0 15px',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                },
                '&:last-child::after': {
                    display: 'none',
                },
            },
            '& .awaitingApprovalRow': {
                display: 'flex',
                alignItems: 'center',
                '& p': {
                    fontSize: '16px',
                    fontWeight: 400,
                    color: '#333333',
                    margin: '0 15px 0 0',
                    textTransform: 'capitalize',
                    '& strong': {
                        fontWeight: 600,
                    }
                }
            },
            '& .basePlanText': {
              backgroundColor: '#FBFBFB',
              padding: '7.5px 10px',
              fontSize: '14px',
              fontWeight: 600,
              color: '#379D0B',
              lineHeight: '142%',
              marginLeft: 'auto',
              '& span': {
                fontSize: '12px',
                color: '#1D7DEA',
                paddingLeft: '11px',
                cursor: 'pointer',
              }
            }
        },
        approved: {
            backgroundColor: 'rgba(255, 194, 1, 0.1)',
        },
        awaiting: {
            background: "#FA4A4A1A"
        },
        rejected: {
            background: '#FA4A4A1A'
        },
        closed: {
            background: '#FA4A4A1A'
        },
        coursePlanRequestModal: {
            position: 'relative',
            maxHeight: '563px',
            minHeight: '563px',
            '&>div>div': {
              paddingTop: '0 !important',
              maxHeight: '485px',
              '&>div': {
                position: 'relative',
                padding: 0,
                '& .title': {
                  fontSize: '20px',
                  fontWeight: 600,
                  lineHeight: '27px',
                  color: '#333333',
                  margin: '0',
                  borderBottom: 'solid 1px #E4E4E4',
                  padding: '16px 10px 10px',
                  textAlign: 'center',
                  position: 'sticky',
                  top: 0,
                  backgroundColor: '#ffffff',
                  zIndex: 9,
                  '& img': {
                    position: 'absolute',
                    right: '15px',
                    top: '20px',
                    cursor: 'pointer',
                  }
                },
                '& .confirmationMessageBox': {
                  padding: '20px 20px 0',
                },
                '& .confirmationMessage': {
                  backgroundColor: 'rgba(29, 125, 234, 0.1)',
                  borderRadius: '4px',
                  padding: '15px',
                  display: 'flex',
                  alignItems: 'flex-start',
                  marginBottom: '15px',
                  '& img': {
                    width: '28px',
                    marginRight: '9px',
                  },
                  '& p': {
                    fontSize: '16px',
                    fontWeight: 400,
                    lineHeight: '138%',
                    color: '#666666',
                    marginBottom: '5px',
                    marginTop: 0,
                    '&:last-child': {
                      marginBottom: 0,
                    }
                  },
                },
                '& .noteText': {
                  fontSize: '14px',
                  fontWeight: 400,
                  lineHeight: '171%',
                  color: '#666666',
                  margin: 0,
                  '& strong': {
                    fontWeight: 700,
                  },
                },
                '& .coursePlanRequestTab': {
                  padding: '15px 20px 23px',
                  display: 'flex',
                  alignItems: 'center',
                  margin: 0,
                  listStyle: 'none',
                  position: 'sticky',
                  top: '54px',
                  backgroundColor: '#fff',
                  zIndex: 9,
                  '& li': {
                    padding: '0 15px',
                    cursor: 'pointer',
                    '&:first-child': {
                      paddingLeft: 0,
                    }
                  },
                  '& li span': {
                    fontSize: '14px',
                    fontWeight: 400,
                    color: '#666666',
                    padding: '0 0 8px',
                    position: 'relative',
                    display: 'block',
                    '&::after': {
                      content: "''",
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      right: 0,
                      width: '100%',
                      height: '4px',
                      backgroundColor: 'transparent',
                      borderRadius: '10px',
                    }
                  },
                  '& li.active span': {
                    fontWeight: 700,
                    color: '#1D7DEA',
                    '&::after': {
                      backgroundColor: '#1D7DEA',
                    }
                  }
                },
                '& .coursePlanRequestContent': {
                  display: 'none',
                  padding: '0 20px',
                  height: 'calc(485px - 114px)',
                  overflow: 'auto',
                  
                  '&::-webkit-scrollbar': {
                    width: '6px',
                  },
                  '&::-webkit-scrollbar-track': {
                    backgroundColor: '#ccc',
                    borderRadius: '10px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#9b9b9b',
                    outline: 'none',
                    borderRadius: '10px',
                  },
                },
                 '& .active': { 
                  display: 'block' 
                },
                '& .ps__rail-y': {
                  display: 'none',
                },  
                '& .mainHeading': {
                  fontSize: '16px',
                  fontWeight: 400,
                  lineHeight: '22px',
                  color: '#333333',
                  margin: '0 0 15px',
                  textTransform: 'capitalize',
                  '& strong': {
                    fontWeight: 600,
                  },
                },
                '& .dateChangeList': {
                  border: '1px solid #E6E6E6',
                  borderRadius: '4px',
                  backgroundColor: '#ffffff',
                  '& ul': {
                    padding: '0 20px',
                    margin: 0,
                    listStyle: 'none',
                    '& li': {
                      borderBottom: '1px solid rgba(153, 153, 153, 0.5)',
                      padding: '15px 0',
                      '&:last-child': {
                        borderBottom: 'none',
                      },
                      '& .dateTitleRow': {
                        marginBottom: '15px',
                        display: 'flex',
                        alignItems: 'center',
                        '& img': {
                          width: '16px',
                          marginRight: '13px',
                        },
                        '& .titleSec': {
                          fontSize: '16px',
                          fontWeight: 400,
                          lineHeight: '138%',
                          margin: 0,
                        }
                      },
                      '& .subTitle': {
                        fontSize: '16px',
                        fontWeight: 400,
                        lineHeight: '138%',
                        color: '#333333',
                        margin: '0 0 5px',
                      },
                      '& .dateTimeSection': {
                        display: 'flex',
                        alignItems: 'center',
                        margin: '0 -7.5px 16px',
                        '& .dateTimeSectionCol': {
                          display: 'inline-flex',
                          alignItems: 'center',
                          padding: '0 7.5px',
                          '& img': {
                            width: '16px',
                            marginRight: '10px',
                          },
                          '& p': {
                            fontSize: '16px',
                            fontWeight: 200,
                            lineHeight: '125%',
                            color: '#333333',
                            margin: 0,  
                          }
                        }
                      },
                      '& .paraText': {
                        fontSize: '12px',
                        fontWeight: 400,
                        lineHeight: '125%',
                        color: '#999999',
                        marginBottom: 0,
                      }
                    }
                  }
                },
                '& .phaseBlockSection': {
                  '& .phaseBlockCol': {
                    marginBottom: '20px',
                    '& .phaseInfoGroup': {
                      marginBottom: '15px',
                      '&>ul': {
                        margin: '0 -20px 0',
                      }
                    },
                    '& .phaseInfo': {
                      backgroundColor: '#FAFAFA',
                      padding: '5px 20px',
                      display: 'flex',
                      listStyle: 'none',
                      margin: '0 -20px 15px',
                      '& li': {
                        fontSize: '12px',
                        fontWeight: 400,
                        color: '#666666',
                        padding: '0 12px',
                        position: 'relative',
                        '&:empty': {
                          display: 'none',
                        },
                        '&.whiteSpaceNoWrap': {
                          whiteSpace: 'nowrap',
                        },
                        '&::before': {
                          content: "''",
                          width: '4px',
                          height: '4px',
                          borderRadius: '50%',
                          backgroundColor: '#D9D9D9',
                          margin: '0 10px',
                          display: 'block',
                          position: 'absolute',
                          left: '-11px',
                          top: '7px',
                        },
                        '&:first-child::before': {
                          display: 'none',
                        },
                        '&:first-child': {
                          paddingLeft: 0,
                        },
                        '&:last-child': {
                          paddingRight: 0,
                        },
                        '& strong': {
                          fontWeight: 600,
                        }
                      }
                    },
                    '& .phasePrevInfo': {
                      backgroundColor: '#FAFAFA',
                      padding: '5px 20px',
                      display: 'flex',
                      listStyle: 'none',
                      margin: '0 -20px 15px',
                      '& li': {
                        fontSize: '12px',
                        fontWeight: 400,
                        color: '#999999',
                        position: 'relative',
                        padding: '0 12px',
                        '&::after': {
                          content: "''",
                          width: '4px',
                          height: '4px',
                          margin: '0 10px',
                          borderRadius: '50%',
                          backgroundColor: '#D9D9D9',
                          top: '7px',
                          left: '-11px',
                          position: 'absolute',
                        },
                        '&:first-child': {
                          paddingLeft: 0,
                          '&::after': {
                            display: 'none',
                          }
                        },
                        '&:last-child': {
                          paddingRight: 0,
                        },
                        '& strong': {
                          fontWeight: 600,
                        },
                        '&.whiteSpaceNoWrap': {
                          whiteSpace: 'nowrap',
                        },
                        '&:empty': {
                          padding: 0,
                          '&::after': {
                            display: 'none',
                          }
                        }
                      }
                    },
                    '& .phaseList': {
                      padding: '0',
                      margin: '0',
                      listStyle: 'none',
                      '& li': {
                        borderBottom: 'solid 1px rgba(153, 153, 153, 0.5)',
                        paddingBottom: '10px',
                        marginBottom: '10px',
                        '&:last-child': {
                          borderBottom: 'none',
                          marginBottom: 0,
                          paddingBottom: 0,
                        },
                        '& .phaseTitle': {
                          fontSize: '16px',
                          fontWeight: 400,
                          lineHeight: '22px',
                          color: '#333333',
                          margin: '0 0 4px',
                        },
                        '& .datePhaseTitle': {
                          fontSize: '16px',
                          fontWeight: 400,
                          lineHeight: '22px',
                          color: '#333333',
                          margin: '0 0 4px',
                          display: 'flex',
                        },
                        '& .datePhaseTitle p': {
                          margin: '0 0 0 5px',
                        },
                        '& .datePhaseLabel': {
                          marginBottom: '5px',
                        },
                        '& .arrowIcon': {
                          margin: '0 5px',
                        },
                        '& .phaseSubTitle': {
                          fontSize: '14px',
                          lineHeight: '19px',
                          fontWeight: 400,
                          color: '#333333',
                          margin: '10px 0 8px',
                        },
                        '& .otherInfo': {
                          fontSize: '12px',
                          fontWeight: 400,
                          color: '#999999',
                          lineHeight: '15px',
                          margin: '12px 0 0',
                          textOverflow: 'ellipsis',
                          overflow: 'hidden',
                          width: '100%',
                          whiteSpace: 'nowrap',
                        },
                      },
                      '& .paraSection': {
                        display: 'flex',
                        '& .iconCol': {
                          width: '24px',
                          minWidth: '24px',
                          height: '24px',
                          marginRight: '5px',
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          '& img': {
                            maxWidth: '100%',
                            maxHeight: '100%',
                          }
                        },
                        '& p': {
                          fontSize: '16px',
                          fontWeight: 200,
                          lineHeight: '20px',
                          color: '#333333',
                          margin: '3px 0 10px',
                          '&:last-child': {
                            marginBottom: 0,
                          }
                        },
                      },
                    }
                  }
                }
              },
              '&:last-child': {
                padding: '20px 20px !important',
                border: 0,
              }
            },
            '& .btnBlue': {
              padding: '0 20px',
              minWidth: '120px',
              fontSize: '16px',
              fontWeight: 400,
            },
        },
        rejectionRemarkModal: {
          position: 'relative',
          maxHeight: '523px',
          '&>div>div': {
            paddingTop: '0 !important',
            '&>div': {
              position: 'relative',
              padding: 0,
              '& .title': {
                fontSize: '24px',
                fontWeight: 600,
                lineHeight: '32px',
                color: '#333333',
                margin: '0',
                borderBottom: 'solid 1px #DCDCDC',
                padding: '16px 10px 14px',
                textAlign: 'center',
                position: 'sticky',
                top: 0,
                backgroundColor: '#ffffff',
                zIndex: 9,
                '& img': {
                  position: 'absolute',
                  right: '15px',
                  top: '20px',
                  cursor: 'pointer',
                }
              },
            },
            '& .ContentArea': {
              padding: '24px 30px 0',
              maxHeight: 'calc(523px - 155px)',
              overflowY: 'auto',
              '&::-webkit-scrollbar': {
                width: '6px',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: '#ccc',
                borderRadius: '10px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#9b9b9b',
                outline: 'none',
                borderRadius: '10px',
              },
              '& p': {
                fontSize: '16px',
                fontWeight: 400,
                lineHeight: '24px',
                color: '#666666',
                margin: '0 0 10px',
                textAlign: 'center',
                '&:last-child': {
                  marginBottom: 0,
                },
              },
            },
            '& .ps__rail-y': {
              display: 'none',
            }, 
            '&:last-child': {
              padding: '24px 40px !important',
              border: 0,
            }
          },
          '& .btnBlue': {
            padding: '0 20px',
            minWidth: '136px',
            height: '44px',
            fontSize: '16px',
            fontWeight: 400,
            margin: '0 auto',
          },
        },
        rejectRequestModal: {
          position: 'relative',
          maxHeight: '523px',
          minHeight: '303px',
          '&>div>div': {
            paddingTop: '0 !important',
            '&>div': {
              position: 'relative',
              padding: 0,
              '& .title': {
                fontSize: '24px',
                fontWeight: 600,
                lineHeight: '32px',
                color: '#333333',
                margin: '0',
                borderBottom: 'solid 1px #DCDCDC',
                padding: '16px 10px 14px',
                textAlign: 'center',
                position: 'sticky',
                top: 0,
                backgroundColor: '#ffffff',
                zIndex: 9,
                '& .closeIcon': {
                  position: 'absolute',
                  right: '22px',
                  top: '24px',
                  cursor: 'pointer',
                },
              },
            },
            '& .textareaContent': {
              margin: '24px 40px 0',
              overflowY: 'auto',
              position: 'relative',
              height: '124px',
              border: 'solid 1px #D8D8D8',
              borderRadius: '4px',
              '&::-webkit-scrollbar': {
                width: '6px',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: '#ccc',
                borderRadius: '10px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#9b9b9b',
                outline: 'none',
                borderRadius: '10px',
              },
              '& textarea': {
                width: '100%',
                height: 'calc(100% - 41px)',
                color: '#333333',
                fontSize: '16px',
                fontWeight: 400,
                fontFamily: 'Nunito',
                padding: '10px 15px',
                resize: 'none',
                display: 'block',
                border: 'none',
                '&::-webkit-input-placeholder': {
                  color: '#666666',
                },
                '&:-ms-input-placeholder': {
                  color: '#666666',
                },
                '&::placeholder': {
                  color: '#666666',
                },
                '&:focus': {
                  outline: 'none',
                }
              },
              '& .textAreaLetters': {
                fontSize: '12px',
                fontWeight: 400,
                color: '#666666',
                position: 'absolute',
                bottom: 0,
                right: 0,
                width: '100%',
                textAlign: 'right',
                padding: '10px 15px 15px',

              },
            },
            '& .ps__rail-y': {
              display: 'none',
            }, 
            '&:last-child': {
              padding: '24px 40px !important',
              border: 0,
            }
          },
          '& .btnBlue': {
            padding: '0 20px',
            minWidth: '100px',
            height: '44px',
            fontSize: '16px',
            fontWeight: 400,
            margin: '0',
          },
        },
    })

export default awaitingRequestStyle;